import React from 'react';
import autoBind from 'react-autobind';
import PropTypes from 'prop-types';
import { List } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import SidebarIcon from '../components/SidebarIcon';
import { Sidebar } from '../';
import SidebarItemFacility from './SidebarItemFacility';
import SidebarItemBuilding from './SidebarItemBuilding';
import { Subscribe, appContainer } from '../../../contexts/app';

import './style.scss';

class SidebarMap extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    const { facility, match, currentUser } = this.props;
    const { params } = match;
    const { facilityId, buildingId, floorId, path: matchPath } = params;
    const { permissions } = currentUser;
    const listWidth = permissions.edit.resources ? null : 306;
    return (
      <div id="Sidebar">
        <Sidebar>
          {permissions.edit.resources && (
            <div className="icon-wrapper">
              <SidebarIcon match={match} matchFacilityId={facilityId} />
            </div>
          )}
          <div
            className={`list-wrapper ${
              permissions.edit.resources ? '' : 'no-icon-wrapper'
            }`}
          >
            <List style={{ padding: 0, width: listWidth }}>
              <SidebarItemFacility facility={facility} matchPath={matchPath} />
              <Divider />
              {facility.buildings().map((building, index) => {
                return (
                  <SidebarItemBuilding
                    key={building._id}
                    index={index}
                    facilityId={facilityId}
                    floorId={floorId}
                    building={building}
                    selected={buildingId === building._id}
                  />
                );
              })}
            </List>
          </div>
        </Sidebar>
      </div>
    );
  }
}

SidebarMap.propTypes = {
  facility: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default props => {
  return (
    <Subscribe
      to={[appContainer]}
      render={app => {
        return (
          <SidebarMap {...props} currentUser={app.state.get('currentUser')} />
        );
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarMap/index.jsx